import HideHeaderButtons from 'src/javascripts/components/tables/checkboxes/HideHeaderButtons';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Bulk merge using selected record IDs from a table
export default function(tableId) {

  // Merge bulk
  $('#mergeBulk').off().on('click', function() {
    let url = $(this).data('url');
    let params = {};
    params['record_ids'] = $('#' + tableId).data('record-ids');
    $.ajax({
      type: 'GET',
      dataType: 'script',
      url: url + '?' + $.param(params),
      complete(result) { 
        $('#' + tableId).DataTable().ajax.reload();
        HideHeaderButtons(tableId);
      }
    });
  })

}